import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, Mail } from 'lucide-react';
import { Logo } from '../components/Logo';

export const SubscriptionCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-primary-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Logo size="lg" className="mx-auto mb-4" />
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-medical-200 p-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-red-600" />
          </div>

          <h1 className="text-3xl font-bold text-medical-900 mb-4">
            Payment Cancelled
          </h1>

          <p className="text-lg text-medical-600 mb-6">
            Your subscription payment was cancelled. No charges have been made.
          </p>

          <div className="bg-cyan-50 border border-cyan-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-cyan-800 mb-2">
              Need help choosing the right plan?
            </p>
            <p className="text-xs text-cyan-700">
              Contact our team for personalised recommendations.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/signup')}
              className="w-full btn-primary flex items-center justify-center space-x-2"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Back to Plans</span>
            </button>

            <button
              onClick={() => navigate('/')}
              className="w-full btn-secondary"
            >
              Return to Home
            </button>
          </div>

          <div className="mt-6 pt-6 border-t border-medical-200">
            <div className="flex items-center justify-center space-x-2 text-sm text-medical-600">
              <Mail className="h-4 w-4" />
              <span>Questions? Email support@clinlexis.co.uk</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
